// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"Iframe_iframeContainer__26z5M","iframe":"Iframe_iframe__C__Od"};